<div [zeroLoadingIndicator]="ongoingRequest" liVariant="1">
  @if (!documentId && !errorMessage) {
    <p>{{ 'trade.confirm.exante.loading' | transloco }}</p>
  }
  @if (errorMessage) {
    <p>
      <span class="text-color-error">{{ 'trade.confirm.exante.error' | transloco: { msg: errorMessage } }}</span>
      <br />
      @if (!documentId) {
        <a class="link-primary link-underline cursor-pointer" (click)="retry()">{{ 'trade.confirm.exante.retry' | transloco }}</a>
      }
    </p>
  }
  @if (documentId) {
    <a class="link-secondary" [href]="uri" target="_blank" rel="noopener noreferrer">
      {{ 'trade.confirm.exante.link' | transloco }}
      @if (isFraction) {
        {{ 'trade.confirm.exante.fraction' | transloco }}
      }
    </a>
  }
</div>
